import React from 'react';
import { KeyboardArrowDown } from '@material-ui/icons';
import Loader from 'react-simple-loading';


class LoadMore extends React.Component {
  render() {
    const { isLoading, loadMore } = this.props;

    return (
      <div className={(isLoading) ? 'load-more-container progress' : 'load-more-container'}>
        <div className="load-more">
          <div className="load-more-progress">
            <Loader />
          </div>
          <span className="load-more-icon" onClick={loadMore}>
            <KeyboardArrowDown fontSize="inherit" />
          </span>
          <span className="load-more-text">
            Load More
          </span>
        </div>
      </div>
    );
  }
}

export default LoadMore;
